import { Box, Skeleton, Typography } from "@mui/material";
import { Grid2 as Grid } from "@mui/material";
import { PaymentReminder } from "../../../../../types";
import { EditIcon } from "../../../../icons";

type ViewOrganizationProfileBodyProps = {
  data?: PaymentReminder;
  isLoading?: boolean;
  handleEditMode: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ViewOrganizationPaymentReminder = ({
  data,
  isLoading,
  handleEditMode,
}: ViewOrganizationProfileBodyProps) => {
  return (
    <Grid
      container
      spacing={{ xs: 0, sm: 2 }}
      sx={{
        width: "100%",
        height: "100%",
        px: 3,
        position: "relative",
      }}
    >
      <Box
        onClick={() => handleEditMode(true)}
        sx={{
          ":hover": {
            cursor: "pointer",
          },
          position: "absolute",
          right: "0.5rem",
          top: "0.5rem",
        }}
      >
        {data && <EditIcon width={"21px"} active={true} />}
      </Box>
      <Grid
        container
        size={{ xs: 12, sm: 6 }}
        gap={3}
        sx={{
          px: { xs: 0, sm: 4 },
          pt: 3,
          pb: { xs: 0, sm: 3 },
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {isLoading ? (
            <Skeleton variant="text" sx={{ fontSize: "2rem" }} />
          ) : (
            <>
              <Typography
                sx={{
                  color: "#606060",
                  textAlign: "left",
                  fontSize: "14px",
                }}
              >
                Payment Reminder
              </Typography>
              <Typography
                sx={{
                  color: "#000",
                  textAlign: "left",
                }}
              >
                {data ? (data.enabled ? "Enabled" : "Disabled") : "N/A"}
              </Typography>
            </>
          )}
        </Box>
      </Grid>
      <Grid
        container
        size={{ xs: 12, sm: 6 }}
        gap={3}
        sx={{
          px: { xs: 0, sm: 4 },
          pt: 3,
          pb: { xs: 0, sm: 3 },
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {isLoading ? (
            <Skeleton variant="text" sx={{ fontSize: "2rem" }} />
          ) : (
            <>
              <Typography
                sx={{
                  color: "#606060",
                  textAlign: "left",
                  fontSize: "14px",
                }}
              >
                Frequency (Days)
              </Typography>
              <Typography
                sx={{
                  color: "#000",
                  textAlign: "left",
                }}
              >
                {data && data.frequencyDays ? data.frequencyDays : "N/A"}
              </Typography>
            </>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
